import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import { IReactSelectOption } from '../../utils/types';
import { ReactSelectMenu } from '../Dropdown/StyledReactSelect';
import { BasicDropdownIndicator } from '../Dropdown/StyledReactSelect/SelectUtils';
import { colors } from '../../config/styles';
import { theme } from '../../styles/theme';

interface IProps<V> {
  value: V;
  onChange: (value?: V) => void;
  options: IReactSelectOption<V>[];
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
  hasError?: boolean;
}

const ReadOnlyLabel = styled.div`
  color: ${theme.colors.mainBlue};
  font-weight: 500;
`;

const FormatValueDropdown = <V,>({
  value,
  onChange,
  options,
  placeholder,
  readOnly,
  disabled,
  hasError,
}: IProps<V>) => {
  const selectedOption = options.find((option) => option.value === value);

  if (readOnly && selectedOption) {
    return <ReadOnlyLabel>{selectedOption.label}</ReadOnlyLabel>;
  }

  return (
    <ReactSelectMenu<IReactSelectOption<V>, false, never>
      isMulti={false}
      options={options}
      onChange={(value) => onChange(value?.value)}
      value={selectedOption}
      components={{
        DropdownIndicator: (props) =>
          BasicDropdownIndicator({ props, color: theme.colors.secondary900 }),
        SingleValue: components.SingleValue,
      }}
      styles={{
        container: (base) => ({
          ...base,
          width: '100%',
        }),
        control: (base) => {
          const result = {
            ...base,
            minWidth: '100%',
            maxWidth: '100%',
          };

          if (hasError) {
            result.borderColor = colors.mainError;
          }

          return result;
        },
        valueContainer: (base) => ({
          ...base,
          paddingLeft: '8px',
        }),
        placeholder: (base) => ({
          ...base,
          margin: 0,
        }),
      }}
      placeholder={placeholder}
      isSearchable={false}
      isClearable={false}
      isDisabled={disabled}
    />
  );
};

export default FormatValueDropdown;
